
import { defineComponent, PropType } from 'vue'

import { TagAttributes } from '@/types/models/tag'
import { toArray } from '@/utils/array'
import { toTagIdsQuery } from '@/types/forms/tag-checkbox'

export default defineComponent({
  props: {
    tags: {
      type: Array as PropType<TagAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  setup() {
    return {
      toArray,
      toTagIdsQuery
    }
  },
})
